var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 13.5002C22.2335 13.5002 25.125 10.6087 25.125 7.04183C25.125 3.475 22.2335 0.583496 18.6666 0.583496C15.0998 0.583496 12.2083 3.475 12.2083 7.04183C12.2083 8.21261 12.5199 9.31062 13.0646 10.2575L9.55926 12.5929C8.61474 11.5627 7.25779 10.9168 5.74998 10.9168C2.89651 10.9168 0.583313 13.2301 0.583313 16.0835C0.583313 18.9369 2.89651 21.2502 5.74998 21.2502C7.42411 21.2502 8.91226 20.454 9.85641 19.2195L14.8769 21.7294C14.8211 21.9913 14.7916 22.2632 14.7916 22.5418C14.7916 24.682 16.5265 26.4168 18.6666 26.4168C20.8068 26.4168 22.5416 24.682 22.5416 22.5418C22.5416 20.4017 20.8068 18.6668 18.6666 18.6668C17.5005 18.6668 16.4548 19.1819 15.7444 19.997L10.7237 17.487C10.8494 17.0408 10.9166 16.5699 10.9166 16.0835C10.9166 15.4347 10.7971 14.8139 10.5788 14.2418L14.2763 11.7784C15.4284 12.8468 16.9712 13.5002 18.6666 13.5002Z",
    fill: "url(#paint0_linear_1027_13962)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1027_13962",
    x1: 0.583313,
    y1: 14.3613,
    x2: 25.125,
    y2: 14.3613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCateIcon);
export default __webpack_public_path__ + "static/media/cate-icon.b512db4c0e6fdffb08669deb1cff891d.svg";
export { ForwardRef as ReactComponent };